import { useEffect, useState } from "react";
import type { GameFragment } from "../../../types";

const checkScrollable = (element: HTMLDivElement): boolean =>
  element.scrollHeight > element.clientHeight;

const useScrollState = (
  scrollContainer: HTMLDivElement | null,
  hasMore: boolean,
  games: GameFragment[],
  isLoading: boolean,
): { isTopScrolled: boolean; showGradient: boolean } => {
  const [isTopScrolled, setIsTopScrolled] = useState<boolean>(true);
  const [showGradient, setShowGradient] = useState<boolean>(false);

  useEffect(() => {
    if (!scrollContainer) return;
    setShowGradient(checkScrollable(scrollContainer));

    const handleScroll = () => {
      setShowGradient(checkScrollable(scrollContainer));

      if (hasMore && scrollContainer.scrollTop > 0) {
        setIsTopScrolled(false);
      } else if (hasMore && scrollContainer.scrollTop <= 0) {
        setIsTopScrolled(true);
      } else if (!hasMore) {
        setIsTopScrolled(true);
      }
    };

    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });

    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [scrollContainer, hasMore, games, isLoading]);

  return { isTopScrolled, showGradient };
};

export default useScrollState;
